export default "__VITE_ASSET__Cm0HP9Mx__"